define('gamebox/math/lerp', ['exports', 'module', './clamp'], function (exports, module, _clamp) {
  'use strict';

  function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

  var _clamp2 = _interopRequire(_clamp);

  'use strict';

  var lerp = function lerp(min, max, amt) {
    var tmpAmt = _clamp2(amt, 0, 1);
    var diff = Math.abs(max - min);

    if (diff === 0) {
      return min;
    } else {
      return min + diff * tmpAmt;
    }
  };

  module.exports = lerp;
});